// Spec §10 — dropdown option lists need arrow-key navigation (Home/End too) between
// `role="option"` elements. Shared by Select, BankSelect, and PhoneInput's dial list,
// which each render their own option buttons inside a DropdownOverlay panel.
const useOptionListKeyDown = (panelRef) => (e) => {
  if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) return
  const options = Array.from(panelRef.current?.querySelectorAll('[role="option"]') ?? [])
  if (options.length === 0) return

  e.preventDefault()
  const currentIndex = options.indexOf(document.activeElement)

  let nextIndex
  if (e.key === 'Home') nextIndex = 0
  else if (e.key === 'End') nextIndex = options.length - 1
  else if (e.key === 'ArrowDown') nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % options.length
  else nextIndex = currentIndex < 0 ? options.length - 1 : (currentIndex - 1 + options.length) % options.length

  options[nextIndex]?.focus()
}

export default useOptionListKeyDown
